(function () {
  var LINK_TEXT = /do not sell or share my personal information/i;
  var SUPPORT_EMAIL = 'support@teamk9.com';
  var FALLBACK_HREF = 'mailto:' + SUPPORT_EMAIL + '?subject=Do%20Not%20Sell%20or%20Share%20My%20Personal%20Information';

  function hasCustomerPrivacyApi() {
    return window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function';
  }

  function setLinkStatus(link, text) {
    var previous = link.textContent;
    link.textContent = text;
    window.setTimeout(function () {
      link.textContent = previous || 'Do Not Sell or Share My Personal Information';
    }, 3500);
  }

  function requestOptOut(link) {
    if (!hasCustomerPrivacyApi()) {
      window.location.href = FALLBACK_HREF;
      return;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(
      { sale_of_data: false, analytics: false, marketing: false },
      function () {
        setLinkStatus(link, 'Privacy choice saved');
      }
    );
  }

  function wirePrivacyLinks() {
    Array.prototype.slice.call(document.querySelectorAll('a')).forEach(function (link) {
      if (!LINK_TEXT.test(link.textContent || '') || link.dataset.tk9PrivacyOptOut === 'true') return;
      link.dataset.tk9PrivacyOptOut = 'true';
      link.href = '#privacy-opt-out';
      link.setAttribute('role', 'button');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        requestOptOut(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wirePrivacyLinks, { once: true });
  } else {
    wirePrivacyLinks();
  }

  new MutationObserver(wirePrivacyLinks).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
